import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import useRefuseDialog from './refuse-dialog.hook';

type Props = {
  hook: any;
};

export default function RefuseDialog({ hook }: Props) {
  const { methods, onSubmit } = useRefuseDialog();
  return (
    <Dialog maxWidth="sm" fullWidth open={hook.openRefuse} onClose={hook.onCloseRefuse}>
      <DialogTitle>Recusar Produto</DialogTitle>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <RHFTextField
              name="declineComment"
              label="Motivo da recusa"
              placeholder="Digite o motivo da recusa do produto..."
              multiline
              rows={4}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={hook.onCloseRefuse} color="inherit">
            Cancelar
          </Button>
          <LoadingButton type="submit" variant="contained">
            Recusar Produto
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
